<span [class]="class + (textValue ? ' withTextValue ' : ' ') + edge" [style.max-width.px]="maxWidth" [style]="style" [id]="generatedId(label) + '_badge'" [attr.role]="click ? 'button' : undefined" data-bs-toggle="tooltip" [attr.data-bs-html]="hintHasTags" data-bs-placement="top" (click)="onBadgeClick($event)" [title]="hint || label">
  <div class="d-flex align-items-center">
    <img *ngIf="img?.length" [src]="img" width="15" height="15">
    <i *ngIf="icon?.length" [class]="icon"></i>
    <div class="text-truncate ms-1">{{label || ""}}</div>
    <span *ngIf="textValue" class="text-truncate textValue rounded-end-pill">{{textValue}}</span>
    <ng-content></ng-content>
  </div>
</span>